import http from '../../../../../shared/http';
import endpoints from '../../../../../../config/endpoints';
import { actions as rootActions } from '../../../../../root';

const createAttachments = ({
	namespace,
	stateNodeName
}) => {
	// action types
	const UPLOAD_SUCCESS = `${namespace}/${stateNodeName}-upload-success`;
	const REQUEST_ERROR = `${namespace}/${stateNodeName}-upload-error`;

	const DELETE_ITEM = `${namespace}/${stateNodeName}-delete-item`;

	const SAVE_SUCCESS = `${namespace}/${stateNodeName}-save-success`;

	const initialState = {};

	// actions
	const actions = {
		attachmentsUpload: files => (dispatch, getState) => {
			const fileData = new FormData();
			const { data: { id } } = getState()['affiliateProfile'];

			for (let i = 0; i < files.length; i++) {
				const file = files[i];
				fileData.append(`images[${i}]`, file);
			}

			const request = http({
				url: endpoints.AFFILIATES.UPLOAD.replace('{id}', id),
				method: 'post',
				actions: [
					UPLOAD_SUCCESS,
					REQUEST_ERROR
				],
				data: fileData
			});

			dispatch(rootActions.spinnerToggle());

			request(dispatch).then(() => dispatch(rootActions.spinnerToggle()));
		},

		attachmentsDelete: fileIndex => ({
			type: DELETE_ITEM,
			payload: fileIndex
		}),

		attachmentsSave: () => (dispatch, getState) => {
			const { data: { id, attachment } } = getState()['affiliateProfile'];

			const request = http({
				url: `${endpoints.AFFILIATES.BASE}/${id}`,
				method: 'put',
				actions: [
					SAVE_SUCCESS,
					REQUEST_ERROR
				],
				data: {
					attachment
				}
			});

			dispatch(rootActions.spinnerToggle());

			request(dispatch).then(() => dispatch(rootActions.spinnerToggle()));
		}
	};

	// reducers
	const reducers = {
		[UPLOAD_SUCCESS]: (state, action) => {
			const paths = action.payload.data.map(entity => entity.path);
			const files = Array.isArray(state.data.attachment) ? state.data.attachment : [];
			return {
				...state,
				showProgressBar: false,
				data: {
					...state.data,
					attachment: [].concat(files, paths)
				}
			};
		},
		[REQUEST_ERROR]: (state, action) => ({ ...state, error: true, showProgressBar: false }),
		[DELETE_ITEM]: (state, action) => {
			const files = state.data.attachment.filter((value, index) => index != action.payload);
			return {
				...state,
				data: {
					...state.data,
					attachment: [].concat(files)
				}
			};
		}
	};

	// selectors
	const selectors = {
		getAttachments: state =>  {
			const files = state[namespace].data && state[namespace].data.attachment;
			return Array.isArray(files) ? files : [];
		}
	};

	return {
		initialState,
		actions,
		reducers,
		selectors
	};
};

export default createAttachments;


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/affiliates/components/profile/forms/attachments/index.js